import { Controller } from 'react-hook-form';

import { ATSConnectHiringRequestCreateReferenceContactIds } from 'data-testids/ATS';
import { FieldContainer } from 'features/Connect/features/ConnectATSIntegration/styles/styles';
import { Input } from 'sharedComponents/Input';
import { Label } from 'sharedComponents/Label';
import { ReferenceFieldProps } from '../../../../types/referenceTypes';
import { RequiredQuestionStar } from 'sharedComponents/Questions/components/QuestionLabel';
import { Stack, useTheme } from '@mui/material';

export const ReferenceField: React.FC<ReferenceFieldProps> = ({
  fieldName,
  formId,
  placeholder,
  isRequired,
  pattern,
}) => {
  const theme = useTheme();

  return (
    <FieldContainer>
      <Stack direction="row">
        <Label
          dataTestId={`${ATSConnectHiringRequestCreateReferenceContactIds.ADD_CONTACT_FIELD}-${fieldName}-label`}
          labelText={fieldName}
        />
        {isRequired && (
          <RequiredQuestionStar
            dataTestId={
              ATSConnectHiringRequestCreateReferenceContactIds.ADD_CONTACT_REQUIRED_FIELD_STAR
            }
          />
        )}
      </Stack>
      <Controller
        name={formId}
        rules={{
          required: isRequired ? 'This field is required' : false,
          pattern,
        }}
        render={({ field: { onChange, value }, fieldState: { error } }) => {
          return (
            <Input
              dataTestId={ATSConnectHiringRequestCreateReferenceContactIds.ADD_CONTACT_FIELD}
              errorText={error?.message}
              hasError={!!error}
              InputProps={{ sx: { borderRadius: theme.spacing(1.25) } }}
              onChange={onChange}
              placeholder={placeholder}
              value={value || ''}
            />
          );
        }}
      />
    </FieldContainer>
  );
};
